import { Box } from '@mui/material';
import { PropsWithChildren, ReactElement } from 'react';

export const EmptyStateTitle = (props: PropsWithChildren): ReactElement => {
    return (
        <Box typography="h5" data-testid="empty-state-title">
            {props.children}
        </Box>
    );
};
